<template>
  <y-vista :vista="vista"></y-vista>
</template>

<script>
import apiServices from "@/services/yungol-services";
import yVista from "@/components/informes/Vista.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      vista: []
    };
  },
  computed: {
    ...mapState(["idtoken"]),
    routestateid(){
      return this.$route.params.id;
    }
  },
  methods: {
    color(c) {
      const size = {
        "col-md-12": "is-12",
        "col-md-4": "is-4",
        "col-md-7": "is-7",
        "col-md-5": "is-5",
        "col-md-6": "is-6"
      };
      return size[c];
    },
    async traeData(_this) {
      let result;
      try {
        if (_this.$route.params.id) {
          result = await apiServices.get(`/informe/${_this.$route.params.id}`);
        } else {
          result = await apiServices.get(`/informeprincipal`);
        }
        _this.vista = result.data.blocks;
      } catch (err) {
        console.log(err);
      }
    }
  },
  watch: {
    idtoken(newv, oldv) {
      if (newv) {
        this.traeData(this);
      }
    },
    routestateid(nv,ov){
      this.traeData(this);
    }
  },
  created() {
    if (this.idtoken) {
      this.traeData(this);
    }
  },
  components: {
    yVista
  }
};
</script>


// WEBPACK FOOTER //
// src/components/informes/View.vue